<template>
    <div>
        <Breadcrumbs main="Shops" title="Shop Insights"></Breadcrumbs>

        
        <!-- <div class="form-group">
            <b-form-select @change="getReport" style="width:150px" v-model="report" :options="reportOptions"></b-form-select>
        </div> -->
        <div class="container-fluid">
            <div class="row ">
                <div v-if="userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-cart" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Total Shops</span>
                          <h4 class="mb-0 counter">{{ shops }}</h4><feather type="shopping-cart" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div v-if="userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-cart" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Monthly Shops</span>
                          <h4 class="mb-0 counter">{{ shops }}</h4><feather type="shopping-cart" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Rated</span>
                          <h4 class="mb-0 counter"> {{ rated }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Monthly Rated</span>
                          <h4 class="mb-0 counter"> {{ rated }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-secondary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Sign ups  </span>
                          <h4 class="mb-0 counter">{{ users }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-secondary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="users" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0"> Monthly Sign ups  </span>
                          <h4 class="mb-0 counter">{{ users }}</h4><feather type="users" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-bag" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Most Visited</span>
                          <h4 class="mb-0 counter">{{ visits }}</h4><feather type="shopping-bag" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="shopping-bag" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Monthly Most Visited</span>
                          <h4 class="mb-0 counter">{{ visits }}</h4><feather type="shopping-bag" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
                <div v-if="!userAdmin" class="col-sm-6 col-xl-3 col-lg-6">
                  <px-card class="bg-primary static-top-widget-card">
                    <div slot="with-padding">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center"><feather type="star" class="middle"></feather></div>
                        <div class="media-body"><span class="m-0">Rated</span>
                          <h4 class="mb-0 counter"> {{ rated }} </h4><feather type="star" class="icon-bg"></feather>
                        </div>
                      </div>
                    </div>
                  </px-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'VendorReport',
        data() {
            return {
                reportOptions: [
                                    { value: null, text: 'Select Report' },
                                    { value: 'T', text: 'Today' },
                                    { value: 'W', text: 'This Week' },
                                    { value: 'M', text: 'This Month' },
                                    { value: 'Y', text: 'This Year' },
                                    { value: 'PW', text: 'Previous Week' },
                                    { value: 'PM', text: 'Previous Month' },
                                    { value: 'PY', text: 'Previous Year' },
                            ],
                report: null,
                items: []
            }
        },
        computed: {
            userAdmin() {
            return localStorage.getItem('type') == "admin" ? true : false
            },
            getUser() {
            return this.$store.getters['authentication/getUser']
            }
        },
        created() {
            // watch and fetch
            this.$watch(
            () => this.$route.$params,
            () => {
                this.fetchData()
            },
            { immediate: true }

            )

        },
        methods: {
            fetchData() {
                axios.get('/Shop')
                    .then(response=>{
                        //
                        this.items = response.data
                    })
                .catch( e => {
                    this.$swal({
                        title:"Failed!",
                        text:e.response.data,
                        type:'error'
                    });
                })
            },
            getReport() {
                console.log(this.report)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>